import * as React from "react";
import styled from "styled-components";

const StyledCardBody = styled("div")`
  padding: 20px;
`;

export const CardBody: React.FC = ({ children }) => (
  <StyledCardBody>{children}</StyledCardBody>
);
